// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Redirect, Route } from "react-router-dom";
import { withRouter } from "react-router";
import { withApollo } from "react-apollo";
import classnames from "classnames";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
// import selectors from "model/selectors";
import SocketsTesting from "./pages/SocketsTesting";

// RELATIVE PATH IMPORTS
// importing default component styles

@withApollo
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {};
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("public")
export default class Public extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
  };

  render() {
    const { theme, match } = this.props;

    return (
      <div className={classnames(theme.app)}>
        <Switch>
          <Route
            exact
            path={`${match.path}/sockets`}
            component={SocketsTesting}
          />
          <Route path="*" render={() => <Redirect to={`/`} />} />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Public/Public.js